














import { Component, Vue, Prop } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { IRule } from '@/helpers/filter-rules'
import { TrackFieldsLabels, TrackFields } from '@/constants'
import { REKORDCLOUD_COLOR_HEX_MAP } from '@/helpers/color'
import { ratingCellRenderer, colorCellRenderer } from '@/helpers/ag-grid/cellRenderer'

interface ILabelFieldValue {
  label: string
  value: string
  field: TrackFields
}

@Component({})
export default class PreviewItem extends Vue {
  @Prop()
  track: Track

  @Prop()
  rules: IRule[]

  readonly colorHexMap = REKORDCLOUD_COLOR_HEX_MAP
  readonly emptyText = '(empty)'

  get artistAlbum(): string {
    let a = this.track.artist

    if (this.track.albumTitle) a += ` - ${this.track.albumTitle}`

    return a
  }

  get visibleTrackProps(): ILabelFieldValue[] {
    const props: ILabelFieldValue[] = []

    for (const rule of this.rules) {
      if (rule.field === TrackFields.Artist || rule.field === TrackFields.Title || rule.field === TrackFields.Album) continue

      if (!props.some(x => x.label === TrackFieldsLabels[rule.field])) {
        let value: string = (this.track as any)[rule.field]

        if (value === null || value === undefined) value = this.emptyText

        props.push({
          label: TrackFieldsLabels[rule.field],
          value,
          field: rule.field
        })
      }
    }

    return props
  }

  generateCellRendererHtml(field: TrackFields): string | null {
    if (field === TrackFields.Color) {
      if (this.track.color) {
        return colorCellRenderer({ value: this.track.color })
      } else {
        return `<span>${this.emptyText}</span>`
      }
    } else if (field === TrackFields.Rating) {
      if (this.track.rating) {
        return ratingCellRenderer({ data: this.track })
      } else {
        return `<span>${this.emptyText}</span>`
      }
    }

    return null
  }
}
